import { z } from "zod"
import validation from '@gap/utils/validation/validation-constants'

const errorMap: z.ZodErrorMap = (error, ctx) => {
   if (error.message) return { message: error.message };
   if (typeof error.path[0] !== "string") return { message: ctx.defaultError }

   // Capatilize first char
   const field = error.path[0].charAt(0).toUpperCase() + error.path[0].slice(1)

   if ('validation' in error && error.validation === 'email') {
      if (!ctx.data) {
         return { message: validation.requiredFieldText }
      }
      return { message: 'Invalid email address' }
   }

   switch (error.code) {
      case z.ZodIssueCode.too_small:
         if (error.minimum === 1) {
            return { message: validation.requiredFieldText }
         }
         return { message: `Field ${field} needs to have at least ${error.minimum} characters` }
      case z.ZodIssueCode.too_big:
         return { message: `Field ${field} cannot exceed ${error.maximum} characters` }
      case z.ZodIssueCode.invalid_enum_value:
         return { message: validation.requiredFieldText }
      case z.ZodIssueCode.invalid_type:
         if (error.received === 'null') {
            return { message: validation.requiredFieldText }
         }
   }

   // Fallback
   return { message: ctx.defaultError }
};

export default errorMap